export const INITIAL_DISCONNECT_TIMER_SECONDS = 100;
export const INITIAL_RETURN_TIMER_SECONDS = 10;
export const CHARGE_SPY_MINIMUM_SECONDS = 120;

export const STREAM_VOLUME_KEY = 'streamVolumeValue';
export const DEFAULT_VOLUME_VALUE = 50;

export const VIDEO_AND_CHAT_CLASS = 'video-chat-wrapper';

export const BROADCAST_STATUS = {
  PLAYING: 'playing',
  RECONNECTING: 'reconnecting',
  DISCONNECTED: 'disconnected',
  INSIDE_PS: 'inside_ps',
  ACCEPTED_INSIDE_PS: 'accepted_inside_ps',
  SPYING: 'spying',
  INSIDE_GS: 'inside_gs',
  UNKNOWN: 'unknown',
};

export const NEW_SHOWS_STATE = {
  ACCEPTING: 'ACCEPTING',
  INSIDE_PS: 'INSIDE_PS',
  PAUSED: 'PAUSED',
  PAUSE_TIMEOUT: 'PAUSE_TIMEOUT',
  GS_SELLING_TICKETS: 'GS_SELLING_TICKETS',
  GS_GOAL_REACHED: 'GS_GOAL_REACHED',
  INSIDE_GS: 'INSIDE_GS',
  GS_SELLING_TICKETS_UNSUCCESSFUL: 'GS_SELLING_TICKETS_UNSUCCESSFUL',
  BONUS_GS: 'BONUS_GS',
  PAUSED_GS: 'PAUSED_GS',
  SHOW_ENDED: 'SHOW_ENDED',
};

export const BROADCAST_TYPE = {
  SOLO: 'solo',
  MALE_FEMALE_GROUP: 'male_female_group',
  MALE_GROUP: 'male_group',
  FEMALE_GROUP: 'female_group',
};

export const SHOW_TYPE = {
  PUBLIC: 'public',
  SOLO_PRIVATE: 'solo_private',
  PRIVATE_BOT: 'ps_bot',
  PRIVATE_PPM: 'ps_ppm',
  C2C_BOT: 'c2c_bot',
  C2C_PPM: 'c2c_ppm',
  GROUP_SHOW: 'gs',
};

export const MY_LIBRARY_VIDEO_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  DELETED: 'DELETED',
  DELETED_BY_USER: 'DELETED_BY_USER',
};

export const VIEW_TYPES = {
  START: 'VIDEO_PLAY',
  CONFIRM: 'CONFIRM_VIDEO_PLAY',
};
